import { Link } from "react-router-dom";
import { PageContainer, PageContent } from "../components/PageContainer";
import { TitleBar } from "../components/TitleBar";

const ErrorPage = () => (
  <div className="w-full h-full grid content-center text-lg">
    <div className="text-center space-y-4">
      <div className="flex flex-col space-y-3 justify-center">
        <div className="text-9xl font-bold">404</div>
        <div className="font-bold text-4xl">Page not found</div>
        <div className="w-72 font-medium place-self-center text-sm">
          Sorry, the page you are looking for doesn't exist.
        </div>
      </div>
      <div>
        <Link
          to="/home"
          className="text-primaryColor font-bold hover:text-grayBg"
        >
          <i className="icon-back_arrow mr-4 font-bold h-12 align-middle" />
          <span className="h-12 align-middle">Back to Home</span>
        </Link>
      </div>
    </div>
  </div>
);

const ModelErrorPage = () => (
  <PageContainer>
    <PageContent>
      <div className="w-full h-full grid content-center text-lg">
        <div className="text-center space-y-4">
          <div className="flex flex-col space-y-3 justify-center">
            <div className="text-9xl font-bold">404</div>
            <div className="font-bold text-4xl">Page not found</div>
            <div className="w-72 font-medium place-self-center text-sm">
              Sorry, the page you are looking for doesn't exist.
            </div>
          </div>
          <div>
            <Link
              to="/home"
              className="text-primaryColor font-bold hover:text-grayBg"
            >
              <i className="icon-back_arrow mr-4 font-bold h-12 align-middle" />
              <span className="h-12 align-middle">Back to Home</span>
            </Link>
          </div>
        </div>
      </div>
    </PageContent>
  </PageContainer>
);

export { ErrorPage, ModelErrorPage };
